import React, { useState } from 'react';
import ModalWrapper from '../../base/modals/modal-wrapper';
import AccountService from './account-service';
import BasicDropdown from '../../base/dropdowns/basic-dropdown';

import './styles/create-account-modal.scss';

const CreateAccountModal = ({ setShowModal, history }) => {
  const CREATOR = 'creator';

  const accountOptions = [
    { label: 'Merchant', value: 'merchant' },
    { label: 'Publisher', value: 'publisher' },
    { label: 'Creator', value: 'publisher', publisher_type: CREATOR },
  ];

  const [fullName, setFullName] = useState('');
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState([]);
  const [accountType, setAccountType] = useState(accountOptions[0]);

  function getParams() {
    const params = {
      full_name: fullName,
      short_name: fullName,
      url,
    };

    if (accountType.publisher_type === CREATOR) params.publisher_type = accountType.publisher_type;
    return params;
  }

  function handleSubmit() {
    setFieldErrors([]);
    AccountService.createAccount(getParams(), accountType.value)
      .then(res => {
        setError('Account created');
        const orgId = accountType.value === 'publisher' ? 'pub_id' : 'merch_id';
        history.push(`/v2/admin/accounts/create/${accountType.value}/${res.data.data[0][orgId]}`);
      })
      .catch(e => {
        if (Array.isArray(e)) {
          setError(`${e && e[0] && e[0].message}`);
          setFieldErrors(e[1]);
        } else {
          setError(`${e && e.message}`);
        }
      });
  }

  return (
    <div className="create-account-modal">
      <ModalWrapper closeModal={() => setShowModal(false)}>
        <h1>Create Account</h1>
        <h2 className="error">{error}</h2>
        <div className="form">
          <div className="form-item user-type">
            <label>Type</label>
            <BasicDropdown
              items={accountOptions}
              selectItem={idx => setAccountType(accountOptions[idx])}
              dropdownLabel={accountType.label}
            />
          </div>
          <div
            className={`form-item full-name ${fieldErrors.includes('full_name') ? 'errored' : ''}`}
          >
            <label>Company</label>
            <input
              type="text"
              className="name"
              value={fullName}
              onChange={e => setFullName(e.target.value)}
            />
          </div>
          <div className={`form-item ${fieldErrors.includes('url') ? 'errored' : ''}`}>
            <label>Url</label>
            <input type="text" className="url" value={url} onChange={e => setUrl(e.target.value)} />
          </div>
        </div>
        <div className="btns">
          <button className="cancel" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button className="create" onClick={handleSubmit}>
            Create Account
          </button>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default CreateAccountModal;
